//TODO : Refactor after ai
import type { ButtonHTMLAttributes, ReactNode } from "react";

export interface SidebarMenuItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  label: ReactNode;
  active?: boolean;
  badge?: ReactNode;
  collapsed?: boolean;
  nested?: boolean;
  trailing?: ReactNode;
}

/** Eine Zeile der Seitenleiste. */
export function SidebarMenuItem({
  icon,
  label,
  active,
  badge,
  collapsed,
  nested,
  trailing,
  className = "",
  ...rest
}: SidebarMenuItemProps) {
  return (
    <button
      type="button"
      className={`bui-nav-item ${className}`}
      data-active={active || undefined}
      data-nested={nested || undefined}
      title={collapsed && typeof label === "string" ? label : undefined}
      style={collapsed ? { justifyContent: "center", padding: 8 } : undefined}
      {...rest}
    >
      {icon && (
        <span style={{ display: "grid", placeItems: "center", width: 20, height: 20, flexShrink: 0 }}>
          {icon}
        </span>
      )}
      {!collapsed && (
        <span
          style={{
            flex: 1,
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </span>
      )}
      {!collapsed && (badge || trailing) && (
        <span className="bui-nav-item__badge">{badge ?? trailing}</span>
      )}
    </button>
  );
}
